import React, { useState, useEffect } from 'react';
import { Box, CircularProgress, Modal } from '@mui/material';
import MyFormRoles from './MyFormRoles';
import EditIcon from '@mui/icons-material/Edit';
import Button from '@mui/material/Button';
import SaveOutlinedIcon from "@mui/icons-material/SaveOutlined";

const Roles = () => {

  const [treeData, setTreeData] = useState([]);
  const [open, setOpen] = useState(false);
  const [openEdit, setOpenEdit] = useState(false);
  const [parentId, setParentId] = useState('');
  const [parentId1, setParentId1] = useState('');
  const [isActive, setisActive] = useState('');
  const [name, setName] = useState('');
  const [nodesvalues, setvalues] = useState('');
  const [defaultpracticeId, setdefaultpracticeId] = useState('');
  const [updatedBy, setupdatedBy] = useState('');
  const [createdBy, setcreatedBy] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [nodeId, setNodeId] = useState('');
  const [applyRefresh, setApplyRefresh] = useState(false);

  const handleClose = () => setOpen(false);
  const handleCloseEdit = () => setOpenEdit(false);

  useEffect(() => {
    fetchTreeData();
  }, [applyRefresh, refresh]);
  const token = localStorage.getItem("Token")

  const fetchTreeData = async () => {
    setSubmitting(true);
    try {
      const defaultpracticeId = localStorage.getItem('default_paractice');
      console.log('abc', defaultpracticeId)
      const response = await fetch(`${process.env.REACT_APP_API_URL}/Module/Roles?defaultpracticeId=${defaultpracticeId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (!response.ok) {
        throw new Error('Failed to fetch tree data');
      }
      const data = await response.json();
      setTreeData(data);
      setSubmitting(false);
    } catch (error) {
      setSubmitting(false);
      console.error('Error fetching tree data:', error);
    }
  };

  const applyRefreshh = () => {
    setApplyRefresh(!applyRefresh);
  };
  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 500,
    height: 300,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    // p: 4,
    borderRadius: '8px'
  };
  return (
    <>
      <Modal
        open={openEdit}
        onClose={handleCloseEdit}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <div><MyFormRoles createdBy={createdBy} update={'update'} applyRefresh={applyRefreshh} defaultpracticeId={defaultpracticeId} name={name} nodesvalues={nodesvalues} updatedBy={updatedBy} handleClose={handleCloseEdit} nodeId={nodeId} parentId={parentId} isActive={isActive} /></div>
        </Box>
      </Modal>

      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <div><MyFormRoles defaultpracticeId={defaultpracticeId} handleClose={handleClose} parentId={parentId1} applyRefresh={applyRefreshh} /></div>
        </Box>
      </Modal>
      {submitting ? (
        <CircularProgress
          style={{
            width: '50px',
            height: '50px',
            position: 'absolute',
            left: '50%',
            top: '70%',
            marginLeft: '-25px',
            marginTop: '25px',
            zIndex: 1000,
            color: '#3C7F6B',
          }}
        />
      ) : null}
      <div>
        <Button
          sx={{ mb: 5 }}
          onClick={() => {
            setOpen(true);
            if (Array.isArray(treeData) && treeData.length > 0) {
              const defaultpracticeId = treeData[0].defaultpracticeId; // Assuming defaultpracticeId is available in the first item of treeData
              console.log(defaultpracticeId, 'default_paractice')
              setdefaultpracticeId(defaultpracticeId)
            }
          }}
          size="large"
          style={{
            backgroundColor: '#3C7F6B', borderRadius: "8px",
            float: 'right',
            color: 'white',
          }}
          startIcon={<SaveOutlinedIcon />}
        >
          ADD NEW
        </Button>

        {Array.isArray(treeData) &&
          treeData.map((node) => (
            <div key={node.id}  style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              backgroundColor: '#a5d6a7', // soft green
              padding: '0.75rem 1rem',
              borderRadius: '8px',
              boxShadow: '0 1px 4px rgba(0,0,0,0.1)',
              marginBottom: '1rem',
              width: '50%',
              transition: 'all 0.3s ease-in-out',
              cursor: 'pointer',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'scale(1.015)';
              e.currentTarget.style.boxShadow = '0 4px 10px rgba(0, 0, 0, 0.2)';
              e.currentTarget.style.backgroundColor = '#81c784'; // darker green
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'scale(1)';
              e.currentTarget.style.boxShadow = '0 1px 4px rgba(0,0,0,0.1)';
              e.currentTarget.style.backgroundColor = '#a5d6a7'; // revert
            }}
            >
              <h3  style={{
          fontSize: '1rem',
          fontWeight: 'bold',
          color: '#333',
          margin: 0,
          flex: 1,
        }}
        >{node.name}</h3>
              <Button
                 size="small"
                 variant="gradient"
                 color="warning"
                 style={{
                   backgroundColor: '#3C7F6B',
                   color: '#fff',
                   minWidth: '70px',
                   height: '32px',
                   textTransform: 'capitalize',
                   fontSize: '0.85rem',
                   borderRadius: '6px',
                   display: 'flex',
                   alignItems: 'center',
                   justifyContent: 'center',
                   padding: '0 12px',
                   transition: 'all 0.3s ease-in-out',
                 }}
                 onMouseEnter={(e) => {
                   e.currentTarget.style.backgroundColor = '#2e6b58';
                 }}
                 onMouseLeave={(e) => {
                   e.currentTarget.style.backgroundColor = '#3C7F6B';
                 }}
                onClick={() => {
                  setOpenEdit(true);
                  setParentId(node.parentId);
                  setupdatedBy(node.updatedBy);
                  setcreatedBy(node.createdBy);
                  setisActive(node.isActive);
                  setNodeId(node.id);
                  setName(node.name);
                  setvalues(node.values);
                  setvalues(node.description);

                  setdefaultpracticeId(node.defaultpracticeId);
                }}
                startIcon={
                  <EditIcon
                    style={{ width: '18px', height: '18px' }}
                  />
                }
              >
              </Button>

            </div>

          ))}
      </div>
    </>
  );
};

export default Roles;
